var render, staticRenderFns
import script from "./phone-experience-data.vue?vue&type=script&lang=js"
export * from "./phone-experience-data.vue?vue&type=script&lang=js"
import style0 from "./phone-experience-data.vue?vue&type=style&index=0&id=746cdc39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746cdc39",
  null
  
)

export default component.exports